<template>
  <!-- <div class="usp-app-ctrl ctrl1 stack-screen-wrap" data-ani="aniGroup" v-if="moduleData.gif"> 
        <div class="usp-app-ctrl-bg-outer">
          <div class="usp-app-ctrl-bg">
            <img
              class="usp-app-ctrl-bg-img"
              :src="moduleData.gif"
              alt
            />
          </div>
        </div>
        <div class="usp-app-ctrl-right" >
          <img
              :src="moduleData.sidePic"
              alt
            />
        </div>
  </div> -->
  <div class="usp-app-ctrl ctrl1" data-ani="aniGroup" v-if="moduleData.gif">
    <div class="usp-app-ctrl-bg-outer">
      <div class="usp-app-mask"></div>
      <div
        :data-animate="
          JSON.stringify([{ start: 0, end: 100, change: [1.6, 1], type: 's' }])
        "
        class="usp-app-ctrl-bg"
      >
        <img
          class="usp-app-ctrl-bg-img "
          :class="device === 'PC' ? 'pc' : device === 'IPAD' ? 'pad' : 'mb'"
          :src="moduleData.gif"
          alt
        />
        <!-- <img
              class="usp-app-ctrl-bg-img pad"
              src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624160649117-pad_usp_04@2x.jpg"
              alt
            />
            <img
              class="usp-app-ctrl-bg-img mb"
              src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624160649405-phone_usp_04@3x.jpg"
              alt
            /> -->
      </div>
    </div>
    <div
      :data-animate="
        JSON.stringify([{ start: 0, end: 60, change: [0, 1], type: 'o' }])
      "
      class="usp-app-ctrl-right"
    >
      <img :src="moduleData.sidePic" alt class="sidePic usp-app-ctrl-phone" />
      <!-- <div class="usp-app-ctrl-title">APP智能控车</div>
          <div class="usp-app-ctrl-desc">可APP寻车、钥匙分享、远程OTA等，一机在手，轻松掌控，用车无忧</div>
          <div
            :data-animate="
              JSON.stringify([
                { start: 0, end: 60, change: [511, 0], type: 'y' },
              ])
            "
            class="usp-app-ctrl-phone"
          >
            <img
              src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623170130709-web_usp_0402@2x.png"
              alt
            />
          </div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "stackScreen",
  props: {
    moduleData: {
      type: Object,
    },
    device: {
      type: String,
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import "@style/base";
@import "@style/common";
@include setThemeClass {
  .usp-app-ctrl {
    position: relative;
    overflow: hidden;
    @include media(
      (
        $home-sm: (
          background-color: getThemeVal(brandColorWhite),
        ),
      )
    );

    .usp-app-mask {
      display: none;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-image: linear-gradient(
        180deg,
        getThemeVal(brandColorBlackOpacity1) 0%,
        rgba(0, 0, 0, 0) 50%
      );
      z-index: 3;
    }
    .usp-app-ctrl-car-box {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 2;
      background: setBgImg(
        "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210625165040369-web_usp_05@1x.jpg",
        cover
      );
      @include media((
            $home-md: (
              background-image:url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630160124144-ipad_car@3x.png),
            ),
            $home-sm: (
              background-image:url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630160124129-phone_car@3x.png),
            ),
          )
        );
      .usp-app-ctrl-car {
        position: absolute;
        top: 30%;
        left: 50%;
        margin-left: vw(-725);
        width: vw(1454);
        height: vw(818);
        background: setBgImg(
          "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210625165040551-car007@3x.png",
          contain
        );
        @include media(
          (
            $home-md: (
              margin-left: -405px,
              width: 810px,
              height: 458px,
              top: 35%,
            ),
            $home-sm: (
              margin-left: -188px,
              width: 375px,
              height: 211px,
              top: 50%,
            ),
          )
        );
        .usp-app-ctrl-car-run {
          position: absolute;
          width: vw(198);
          height: vw(198);
          background: setBgImg(
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210625165039906-before@3x.png",
            contain
          );
          @include media(
            (
              $home-md: (
                width: 111px,
                height: 111px,
              ),
              $home-sm: (
                width: 51px,
                height: 51px,
              ),
            )
          );
        }
        .run1 {
          top: vw(402);
          left: vw(239);
          @include media(
            (
              $home-md: (
                top: 227px,
                left: 132px,
              ),
              $home-sm: (
                top: 105px,
                left: 62px,
              ),
            )
          );
        }
        .run2 {
          top: vw(402);
          right: vw(255);
          @include media(
            (
              $home-md: (
                top: 227px,
                right: 139px,
              ),
              $home-sm: (
                top: 105px,
                right: 65px,
              ),
            )
          );
        }
      }
    }
  }
  .usp-app-ctrl-bg-outer {
    position: relative;
  }
  .usp-app-ctrl-bg {
    .usp-app-ctrl-bg-img {
      width: 100%;
      height: auto;
    }
  }

  .usp-app-ctrl-title {
    position: relative;
    z-index: 3;
    margin-top: vw(100);
    padding: 0 20px;
    @include h1-s(getThemeVal(brandColorWhite), vw);
    @include media(
      (
        $home-md: (
          margin-top: 60px,
          font-size: 36px,
          line-height: 48px,
        ),
        $home-sm: (
          margin-top: 40px,
          font-size: 28px,
          line-height: 42px,
        ),
      )
    );
  }
  .usp-app-ctrl-desc {
    position: relative;
    z-index: 3;
    margin-top: vw(20);
    padding: 0 20px;
    @include h3-s(getThemeVal(brandColorWhite), vw);
    @include media(
      (
        $home-md: (
          margin-top: 10px,
          font-size: 14px,
          line-height: 30px,
        ),
      )
    );
  }
  .usp-app-ctrl-top {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    text-align: center;
    z-index: 10;
  }
  .usp-app-ctrl-right {
    position: absolute;
    width: vw(900);
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    text-align: center;
    z-index: 10;
    background-color: getThemeVal(navColorBlackOpacity2);
    @include media(
      (
        $home-md: (
          width: 52%,
        ),
        $home-sm: (
          width: 100%,
          background-color: transparent,
          position: relative,
          right: auto,
          top: auto,
          bottom: auto,
          padding-bottom: 40px,
        ),
      )
    );
    img {
      &.usp-app-ctrl-phone {
        margin: 0 auto;
        // margin-top: vw(60);
        // width: vw(440);
        width: 100%;
        height: auto;
        display: block;
        // @include media(
        //   (
        //     $home-md: (
        //       margin: 118px auto 0,
        //       width: 297px
        //     ),
        //     $home-sm: (
        //       margin-top: 324px
        //     )
        //   )
        // );
        @include media(
          (
            $home-bg: (
              width: 100%,
              margin-top: 0px,
            ),
            $home-md: (),
            $home-sm: (
              margin-top: 324px,
              width: 297px,
            ),
          )
        );
      }

      // img {
      //   width: 100%;
      //   height: auto;
      // }
    }
  }
  .ctrl1 {
    overflow: hidden;
    .usp-app-ctrl-bg-outer {
      @include media(
        (
          $home-sm: (
            position: absolute,
            top: 0,
            left: 0,
            right: 0,
            z-index: 1,
          ),
        )
      );
    }
  }
}
</style>
